export default "__VITE_ASSET__BN8aW2Hq__"